<template>
  <div class="app" :lang="currentLocale">
    <NavBar />
    <AreaHeroSection id="hero" />
    <AreaAbout id="about" />
    <AreaPartners id="partners" />
    <AreaDataBusiness id="business" />
    <AreaDataPlatform id="platform" />
    <AreaComputingCenter id="computing" />
    <AreaTEUContainer id="facilities" />
    <AreaComputingFacilities id="computing-facilities" />
    <AreaNews id="news" />
    <AreaLinkWe id="contact" />
    <AreaFooter />
    <div
      v-show="showScrollTop"
      class="scroll-top"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
      @click="scrollToTop"
      :style="{
        backgroundImage: `url(${isHovered ? hoverImage : defaultImage})`,
      }"
    ></div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

import NavBar from '@/components/NavBar/index.vue';
import AreaHeroSection from '@/components/AreaHeroSection/index.vue';
import AreaAbout from '@/components/AreaAbout/index.vue';
import AreaPartners from '@/components/AreaPartners/index.vue';
import AreaDataBusiness from '@/components/AreaDataBusiness/index.vue';
import AreaDataPlatform from '@/components/AreaDataPlatform/index.vue';
import AreaComputingCenter from '@/components/AreaComputingCenter/index.vue';
import AreaTEUContainer from '@/components/AreaTEUContainer/index.vue';
import AreaComputingFacilities from '@/components/AreaComputingFacilities/index.vue';
import AreaNews from '@/components/AreaNews/index.vue';
import AreaLinkWe from '@/components/AreaLinkWe/index.vue';
import AreaFooter from '@/components/AreaFooter/index.vue';

// state
const isHovered = ref(false);
const scrollY = ref(0);
const defaultImage = require('@/assets/img/pc/scroll-top.png');
const hoverImage = require('@/assets/img/pc/scroll-top-hover.png');

// computed
const showScrollTop = computed(() => {
  return scrollY.value > window.innerHeight - 300;
});

// lifecycle
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

// methods
function handleScroll() {
  scrollY.value = window.scrollY;
}

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
</script>

<style lang="scss">
@import '@/css/pc/en.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.scroll-top {
  position: fixed;
  right: 30px;
  bottom: 90px;
  width: 56px;
  height: 56px;
  z-index: 100;
  cursor: pointer;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.3s ease;
}

.scroll-top:hover {
  background-image: url('@/assets/img/pc/scroll-top-hover.png');
  transform: scale(1.1);
}
</style>
